module.exports = __webpack_public_path__ + "img/osfatunalt-30-b.78c94cf4.svg";